import { config } from "../config";

const base = config.apiUrl;

export const endpoints = {
  caregivers: "v2/caregivers",
  users: "v2/users",
  sessions: "v2/sessions",
  twilio: "v2/twilio",
  organizations: "v2/organizations",
  settings: "settings",
  notifications: "notifications",
  userNotifications: "users",
  admin: "admin",
  classes: "courses",
  featureFlags: "featureflags",
  events: "events",
  images: "v2/images",
  checkr: "v2/checkr/candidate",
  recording: "twilio/compositions",
  ratings: "v2/ratings",
};

export const getPath = ({ endpoint, path = [], queryParameters = {} }) => {
  if (!Object.values(endpoints).includes(endpoint))
    throw new Error(`${endpoint} is not a supported endpoint`);

  let apiEndpoint = `${base}/${endpoint}`;
  if (path.length > 0) {
    apiEndpoint = [apiEndpoint, path.join("/")].join("/");
  }
  let queryString = [];

  Object.keys(queryParameters).forEach((q) => {
    queryString.push(`${q}=${queryParameters[q]}`);
  });

  if (queryString.length > 0) apiEndpoint += `?${queryString.join("&")}`;

  return apiEndpoint;
};

export const paramPath = (params) => {
  let searchParams = [];
  if (params) {
    Object.keys(params).forEach((p) => {
      // searchParams.push(p);
      searchParams.push({ p: params[p] });
    });
  }
  return searchParams;
};
